import { render, staticRenderFns } from "./InfoPopup_ProjectQuestions.vue?vue&type=template&id=c264d2fe&scoped=true"
import script from "./InfoPopup_ProjectQuestions.vue?vue&type=script&lang=ts"
export * from "./InfoPopup_ProjectQuestions.vue?vue&type=script&lang=ts"
import style0 from "./InfoPopup_ProjectQuestions.vue?vue&type=style&index=0&id=c264d2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c264d2fe",
  null
  
)

export default component.exports